// extracted by mini-css-extract-plugin
export default {"avatar":"UserNav_avatar__mthn8","avatarMenu":"UserNav_avatarMenu__qNTz5","item":"UserNav_item__cz4ia","closeMenu":"UserNav_closeMenu__BnaJT"};